$(".more-info").on("click", function () {
  const id = $(this).data("id");
  if (!$(this).hasClass("active")) {
    $(this).addClass("active");
    $(".more-info__content[data-id='" + id + "']")
      .css("display", "flex")
      .hide()
      .slideDown(400);
  } else {
    $(this).removeClass("active");
    $(".more-info__content[data-id='" + id + "']").slideUp(300);
  }
});
